var _ = require('lodash');
module.exports = Function(_.keys(_.templateSettings.imports), 'return ' + function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="CollapsibleToggleRegion MenuItemPassive MenuButton">\n	<div class="MenuInline MenuIcon"><i class="fa '+
((__t=( d.icon ))==null?'':__t)+
'"></i></div>\n	<div class="MenuInline MenuLabel">'+
((__t=( d.label ))==null?'':__t)+
'</div>\n</div>';
}
return __p;
}.toString()).apply(undefined, _.values(_.templateSettings.imports));
